import { supabase } from '@/shared/lib/supabase';
import type { JukeboxCliente } from '../presentation/contexts/JukeboxClienteContext';
import type { HistoricoPagina, PerfilCompleto } from '../domain/entities/PerfilJukebox';

export async function syncWhatsappProfile(
  telaId: string,
  cliente: JukeboxCliente,
): Promise<JukeboxCliente | null> {
  const { data, error } = await supabase.functions.invoke('jukebox-auth-otp', {
    body: {
      action:       'sync_profile',
      tela_id:      telaId,
      token:        cliente.token,
      cliente_id:   cliente.id,
      phone_e164:   cliente.phone_e164,
    },
  });

  if (error || !data?.ok || !data.cliente) return null;
  return { ...(data.cliente as Omit<JukeboxCliente, 'token'>), token: cliente.token };
}

export function enviarOtp(telaId: string, sessionId: string, phoneE164: string) {
  return supabase.functions.invoke('jukebox-auth-otp', {
    body: {
      action: 'send_otp',
      tela_id: telaId,
      session_id: sessionId,
      phone_e164: phoneE164,
    },
  });
}

export function verificarOtp(telaId: string, sessionId: string, phoneE164: string, codigo: string) {
  return supabase.functions.invoke('jukebox-auth-otp', {
    body: {
      action: 'verify_otp',
      tela_id: telaId,
      session_id: sessionId,
      phone_e164: phoneE164,
      codigo,
    },
  });
}

export async function buscarHistorico(token: string, offset: number, limit = 20): Promise<HistoricoPagina | null> {
  const { data } = await supabase.rpc('jukebox_buscar_historico' as never, {
    p_token: token,
    p_limit: limit,
    p_offset: offset,
  } as never);
  return (data as unknown as HistoricoPagina | null) ?? null;
}

export async function buscarPerfilCompleto(token: string): Promise<PerfilCompleto | null> {
  const { data } = await (supabase.rpc('jukebox_perfil_completo' as never, { p_token: token } as never) as unknown as Promise<{ data: unknown }>);
  return (data as PerfilCompleto | null) ?? null;
}

export async function atualizarPerfil(
  token: string,
  campos: { nome?: string; notificacoes?: boolean },
): Promise<void> {
  await (supabase.rpc('jukebox_atualizar_perfil' as never, {
    p_token: token,
    ...(campos.nome !== undefined && { p_nome: campos.nome }),
    ...(campos.notificacoes !== undefined && { p_notificacoes: campos.notificacoes }),
  } as never) as unknown as Promise<unknown>);
}
